export default __webpack_public_path__ + "static/media/norton-secured@3x.18995ccf.jpg";